import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { IdpType, IdpProtocol } from '../../../../models/sso-idp.model';
import { SsoIdpBaseService, IdpBaseModel } from '../sso-idp-base.service';
import { OktaModel, OktaSettingsModel, OktaSetupModel } from './sso-okta.model';

@Injectable()
export class SsoOktaService extends SsoIdpBaseService<OktaSettingsModel> {
  create({ is_default, name, public_id, settings }: IdpBaseModel<OktaSettingsModel>): Observable<OktaModel> {
    return this.ssoIdpHttpService
      .createGenericSaml({
        idp: IdpType.Okta,
        is_default,
        name,
        public_id,
        settings,
      })
      .pipe(
        tap((idp) => {
          this.authStore.addSsoIdp(idp);
        }),
      );
  }

  update({ is_default, name, public_id, settings }: IdpBaseModel<OktaSettingsModel>): Observable<OktaModel> {
    return this.ssoIdpHttpService
      .updateGenericSaml({
        idp: IdpType.Okta,
        is_default,
        name,
        protocol: IdpProtocol.Saml,
        public_id,
        settings,
      })
      .pipe(
        tap((idp) => {
          this.authStore.updateSsoIdp(idp);
        }),
      );
  }

  getSetup(): Observable<OktaSetupModel> {
    return this.ssoIdpHttpService.getSamlSetup();
  }
}
